import React, { useEffect, useState } from 'react';
// import icon1 from '../images/folder_ok.png';
// import icon2 from '../images/folder_nok.png';
// import icon1 from '../images/green_folder_1.png';
// import icon2 from '../images/red_folder_1.png';

// import icon1 from '../images/coins_14727445.png';
// import icon2 from '../images/coins_14727453.png';

import icon1 from '../images/coins_13470111.png';
import icon2 from '../images/coins_13470097.png';

// import icon1 from '../images/coins_13470461.png';
// import icon2 from '../images/coins_13470097.png';

import './DatasetList.css'; // Importez le fichier CSS
import axios from 'axios';
import { DATASET, globalSetDataset, modeExecution, SITE_WEB  } from './Global.js';




const DatasetList = ({ setSingleSelectedDataset, setSingleDatasetCharacteristics, onTreasureDeselect }) => {

    const [singleDatasets, setDatasets] = useState([]); 

    //=======================================================
    // Requête pour récupérer la liste des utilisateurs
    useEffect(() => {

      const token = sessionStorage.getItem('token'); // Récupérer le token stocké
      // console.log("[DatasetList] Token :")
      // console.log(token)
      console.log("[DatasetList] process.env.REACT_APP_API_URL :", process.env.REACT_APP_API_URL);

      let url = '';
      url = SITE_WEB + '/datasets'
      console.log("[ListeDatasets] [DatasetList] url = ", url)

        axios.get(url, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
          .then(response => {
            console.log("response.data:", response.data)
            setDatasets(response.data);
          })
          .catch(error => {
            console.error('Erreur:', error);
          });

    }, []);
  



  //=======================================================
  // Fonction pour choisir l'icône en fonction du type
  const getIcon = (valdispo) => {
    return valdispo === 'true' ? icon1 : icon2;
  };


  //=======================================================
  const handleClick = async (datasetName, datasetDispo) => {
    let _dump = true;
    if(_dump) console.log("[ListeDatasets] handleClick - dataset:", datasetName);

    // Réinitialiser les états du trésor
    if (onTreasureDeselect) {
      onTreasureDeselect();
    }

    if (datasetDispo === 'false') {
      console.log("((((((((((((((((( handleClick : le DATASET est : ", datasetName)
      setSingleSelectedDataset(datasetName);
      setSingleDatasetCharacteristics({
          numberOfCoins: 0,
          numberOfPotentialLinks: 0,
          results: {
              '-1': 0,
              '1': 0,
              '0.75': 0,
              '0.5': 0,
              '0.25': 0,
              '0': 0
          },
          message: 'Dataset unavailable. Computing in progress (try later), or problem during computing (contact administrator about this dataset)'
      });
    } else
      {
        // alert('Want to see the results on dataset ${datasetName}?');
        globalSetDataset(datasetName);
        console.log("((((((((((((((((( handleClick : le DATASET est : ", DATASET)
        // console.log(DATASET)
        // alert('Dataset available ${datasetName}')

        // Fetch dataset characteristics
        try {
          const token = sessionStorage.getItem('token');
          if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          }

          let response;
          let route_tmp = SITE_WEB + '/dataset-characteristics'
          console.log("[ListeDatasets] [handleClick] route_tmp = ", route_tmp)

              response = await axios.get(route_tmp, {
                params: { dataset: datasetName },
              headers: { 'Authorization': `Bearer ${token}` }
            });


          await setSingleSelectedDataset(datasetName);
          await setSingleDatasetCharacteristics(response.data);

        } catch (error) {
          console.error('Erreur lors de la récupération des caractéristiques du dataset :', error);
        }

      }
  }; // handleClick


  //=======================================================
return (
  <div className="dataset-list-container">
    <ul className="dataset-list">
      {Array.isArray(singleDatasets) ? (
        singleDatasets.map((aDataset, index) => (
          <li
            key={index}
            className="dataset-item"
            onClick={() => handleClick(aDataset.name, aDataset.dispo)}
          >
            <img
              src={getIcon(aDataset.dispo)}
              alt="Icone"
              className="dataset-icon"
            />
            <span className="dataset-name" style={{ color: aDataset.dispo === 'false' ? '#808080' : 'inherit' }}>
              {aDataset.name} {aDataset.dispo === 'false' && '(computing...)'}
            </span>
          </li>
        ))
      ) : (
        <li>Loading datasets...</li>
      )}
    </ul>
  </div>
);

};

export default DatasetList;
